<script lang="ts">
import { PropType, defineComponent, h, type VNode } from 'vue';

import { IDeal } from '@/bundles/Deal/types';
import { getDealTransactionTypeLabel } from '@/bundles/Deal/helpers/transaction/getDealTransactionLabel';
import { formatCurrency, formatDate, formatNumber } from '@/utils/filters';
import { LocalizationEnum } from '@/bundles/Localization/enum/LocalizationEnum';
import i18n from '@/bundles/Localization';

import BuildingSizeLabel from '@/bundles/MeasurementUnits/components/BuildingSizeLabel.vue';
import LandSizeLabel from '@/bundles/MeasurementUnits/components/LandSizeLabel.vue';
import Label from '@/bundles/Common/components/Label.vue';

export default defineComponent({
  name: 'DealCardRelatedContent',

  props: {
    deal: {
      type: Object as PropType<IDeal>,
      required: true
    }
  },

  render (): VNode {
    const { deal } = this;
    const children = [
      h('div', [
        h('strong', `${i18n.t(LocalizationEnum.transaction_type)}: `),
        h('span', { style: { textTransform: 'capitalize' } }, getDealTransactionTypeLabel(deal))
      ]),

      h('div', [
        h('strong', 'Property Type: '),
        h(Label, { style: { textTransform: 'capitalize' }, value: deal.property?.type }),
      ]),

      deal.suite
        ? h('div', [
          h('strong', 'Suite #: '),
          h('span', deal.suite)
        ])
        : null,

      deal.transaction && 'total_square_feet' in deal.transaction
        ? h('div', [
          h('strong', 'Space Size: '),
          h(BuildingSizeLabel, { value: formatNumber(deal.transaction.total_square_feet) })
        ])
        : null,

      deal.transaction && 'total_acres' in deal.transaction
        ? h('div', [
          h('strong', 'Land Size: '),
          h(LandSizeLabel, { value: deal.transaction.total_acres })
        ])
        : null,

      deal.transaction && 'consideration' in deal.transaction
        ? h('div', [
          h('strong', 'Total Consideration: '),
          h('span', formatCurrency(deal.transaction.consideration))
        ])
        : null,

      deal.transaction && 'total_commission' in deal.transaction
        ? h('div', [
          h('strong', 'Total Commission: '),
          h('span', formatCurrency(deal.transaction.total_commission))
        ])
        : null,

      h('div', [
        h('strong', 'Transaction Date: '),
        h(Label, {
          value: deal.transaction?.transaction_date || deal.transaction_date
            ? formatDate(deal.transaction?.transaction_date || deal.transaction_date)
            : null
        })
      ])
    ];

    return h('div', children.filter(Boolean));
  }
})
</script>
